import attachAddressAutocomplete from 'foundation/js/address/addressAutocomplete'
import { isAddressServiceAvailable } from 'foundation/js/address/addressLookup'
import { onBeforeUnmount, onMounted } from 'vue'

export default {
    name: 'FormAddressFieldGroup',
    props: {
        rootElement: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        let detachAutocomplete

        onMounted(async () => {
            const root = props.rootElement
            const mainInput = root.querySelector('.kb-address-line')
            const zipcodeInput = root.querySelector('.kb-address-zipcode')
            const cityInput = root.querySelector('.kb-address-city')

            if (!mainInput) return

            // Se: "Google Chrome forces autofill on fields set autocomplete="off"""
            // https://github.com/alphagov/accessible-autocomplete/issues/325
            // Note: This is also defined in the razor cshtml file
            // We unfortunately need to delay setting the autocomplete attribute
            // since either chrome or froms tries to manipulate this after the
            // document is loaded.
            setTimeout(() => {
                mainInput.attributes['autocomplete'].value = 'chrome-off'
            }, 1)

            const unlockFields = () => {
                zipcodeInput?.removeAttribute('disabled')
                cityInput?.removeAttribute('disabled')
            }

            if (!(await isAddressServiceAvailable())) {
                unlockFields()
                return
            }

            detachAutocomplete = attachAddressAutocomplete(mainInput, {
                onSelect: (address) => {
                    // Episerver Forms reads the values off the DOM and its
                    // validation listens for the events, so setting value alone
                    // is not enough.
                    setFieldValue(zipcodeInput, address.zipCode)
                    setFieldValue(cityInput, address.city)
                    // The autocomplete has already written the address line -
                    // an input event here would start a fresh search.
                    mainInput.dispatchEvent(new Event('change', { bubbles: true }))
                },
                onError: unlockFields
            })
        })

        onBeforeUnmount(() => {
            if (detachAutocomplete) {
                detachAutocomplete()
            }
        })
    }
}

function setFieldValue(input, value) {
    if (!input) return

    input.value = value
    input.dispatchEvent(new Event('input', { bubbles: true }))
    input.dispatchEvent(new Event('change', { bubbles: true }))
}
